import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Button } from "components/core/Button";
import { Map, List, FilterIconSolid } from "components/core/Icons";
import ClickToCall from "components/brand/ClickToCall/ClickToCall";
import { useTollfreeNumber } from "hooks/useTollfreeNumber";
import useActiveFilterCount from "hooks/search/useActiveFilterCount";
import SearchPageContext from "pages/SearchPageV1/SearchPageV1Context";
import { FiltersCard } from "components/organisms/search/Filters";

import "./ClickToCallTray.scss";

const ClickToCallTray = ({ isMapView, onToggleMapView }) => {
  const { isCallCenterOpen, searchFilters, handleFilterChange } = useContext(SearchPageContext);
  const { phone, handleFetchNumber } = useTollfreeNumber();
  const [showFilters, setShowFilters] = useState(false);

  const activeFilterCount = useActiveFilterCount(searchFilters);

  const handleOpenFilters = () => {
    setShowFilters((isOpen) => !isOpen);
  };

  

  return (
    <div className="click-to-call-tray" role="toolbar" aria-label="Search tools">
      

      {showFilters && (
        <div className="click-to-call-tray__filters-modal" role="dialog" aria-label="Filters">
          <FiltersCard
            onFilterChange={handleFilterChange}
            navigateOnChange
            activeFilters={searchFilters}
            onClose={() => setShowFilters(false)}
          />
        </div>
      )}

     <div className="click-to-call-tray__buttons-container">
       <Button
        onClick={onToggleMapView}
        className="tray-button tray-button--toggle"
        label={isMapView ? "List" : "Map"}
      >
        {isMapView ? (
          <List size="large" fill="white" aria-hidden />
        ) : (
          <Map size="large" fill="white" aria-hidden />
        )}
        <span className="tray-button__label">{isMapView ? "List" : "Map"}</span>
      </Button>

      <Button
        onClick={handleOpenFilters}
        className={classNames("tray-button tray-button--with-badge", { "is-active": !!showFilters })}
        label={activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter"}
        aria-pressed={showFilters ? "true" : "false"}
      >
        <FilterIconSolid size="large" fill="white" aria-hidden />
        <span className="tray-button__label">Filter</span>
        {activeFilterCount > 0 && (
          <span className="tray-button__badge">{activeFilterCount}</span>
        )}
      </Button>

       {!!isCallCenterOpen && (
         <ClickToCall
           className="tray-button tray-button--call"
           color="white"
           showIcon
           underline={false}
           phone={phone}
           handleFetchNumber={handleFetchNumber}
           iconSize="large"
         />
       )}
     </div>
    </div>
  );
};

ClickToCallTray.propTypes = {
  isMapView: PropTypes.bool.isRequired,
  onToggleMapView: PropTypes.func.isRequired
};

export default ClickToCallTray;
